import { TenantSubdomain } from "features/types";

type StoredAuth = {
  username: string;
  id: string | number;
};

export const authKey = "auth";
export const themeKey = "theme";
export const subdomainKey = "subdomain";

function parseStorageItem<T>(key: string): T | null {
  try {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export const setStoredAuth = (value: StoredAuth) =>
  localStorage.setItem(authKey, JSON.stringify(value));

export const getStoredAuth = (): StoredAuth | null =>
  parseStorageItem<StoredAuth>(authKey);

export const getStoredTenantSubdomain = (): { subdomain: TenantSubdomain } | null =>
  parseStorageItem<{ subdomain: TenantSubdomain }>(subdomainKey);

export const setStoredTenantSubdomain = (value: TenantSubdomain) =>
  localStorage.setItem(subdomainKey, JSON.stringify({ subdomain: value }));

export const removeStoredTenantSubdomain = () =>
  localStorage.removeItem(subdomainKey);

export const setAutoReservePopup = (value: boolean) =>
  localStorage.setItem("autoReservePopup", JSON.stringify(value));

export const getAutoReservePopup = (): boolean | null =>
  parseStorageItem<boolean>("autoReservePopup");
